import { cn } from "../../lib/utils";
import { Tag } from "./Tag";

/**
 * The number of a cited source (Figma "CitationChip"): a mint `Tag` holding
 * the number and nothing else.
 *
 * Mint whatever the source is: the number says WHERE in the list to look, and
 * nothing else. Provenance is read off the row itself — a journal takes "In",
 * a hostname takes "On" — not off the chip's colour.
 *
 * `md` is the 24 square beside a row of the source list and atop a
 * `SourceCard`; `sm` is the 20 square an answer's inline citation renders as,
 * and it carries its own inline alignment so the two never drift apart. Both
 * widen past their square for a two-digit number. A number means nothing on
 * its own: it is only ever the number of a row in the `ChatSources` list
 * beside it.
 */
export function CitationChip({
  number,
  size,
}: {
  number: number;
  size: "sm" | "md";
}): React.JSX.Element {
  return (
    <Tag
      size="md"
      variant="mint"
      state="idle"
      icon={null}
      className={cn(
        "shrink-0 justify-center px-1 py-0",
        size === "md" ? "h-6 min-w-6" : "mx-0.5 h-5 min-w-5 align-middle"
      )}
    >
      {number}
    </Tag>
  );
}
